import FormInput from 'src/components/form-input';
import { twMerge } from 'tailwind-merge';

import { IEdgeExtraData } from '../types';

export function CustomEdgeEditDescription({
  data,
  onChangeEdgeData,
}: {
  data: IEdgeExtraData;
  onChangeEdgeData: (data: Partial<IEdgeExtraData>) => void;
}) {
  const { useCustomDescription = false, customDescription = '' } = data || {};

  return (
    <div
      className="mt-2 flex flex-col items-start justify-center gap-2"
      data-testid="dialog-custom-edge-edit-description-panel"
    >
      <span className="block text-left text-sm font-medium leading-6 text-gray-900">
        Connection description
      </span>
      <div className="w-full space-y-2">
        <div className="relative flex items-center">
          <div className="flex h-6 items-center">
            <input
              name="useCustomDescription"
              data-testid="dialog-custom-edge-edit-description-use-device-name-radio"
              type="radio"
              id="useDeviceName"
              checked={!useCustomDescription}
              onChange={() =>
                onChangeEdgeData({
                  useCustomDescription: false,
                  customDescription: '',
                })
              }
              className="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden"
            />
          </div>
          <div className="ml-3 text-sm/6">
            <label htmlFor="useDeviceName" className="text-gray-900">
              Use the name of the connected device
            </label>
          </div>
        </div>
        <div className="relative flex items-center">
          <div className="flex h-6 items-center">
            <input
              name="useCustomDescription"
              data-testid="dialog-custom-edge-edit-description-use-custom-description-radio"
              id="useCustomDescription"
              type="radio"
              checked={useCustomDescription}
              onChange={() => onChangeEdgeData({ useCustomDescription: true })}
              className="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden"
            />
          </div>
          <div className="ml-3 flex-1 text-sm/6">
            <FormInput
              data-testid="dialog-custom-edge-edit-description-input"
              id="custom-edge-description"
              name="customDescription"
              value={customDescription || ''}
              wrapperClassName="w-full"
              onChange={(e) =>
                onChangeEdgeData({ customDescription: e.target.value })
              }
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onChangeEdgeData({ useCustomDescription: true });
              }}
              className={twMerge(
                'w-full',
                !useCustomDescription && 'bg-gray-100',
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
